module.exports = __webpack_public_path__ + "static/media/mtTalinis.39cb486b.jpg";